import { struct } from 'io-ts/Decoder';

import { PagesType as PagesToCompare } from '../../../../fpc/pages-to-compare/Type';

export const Request = struct({
	pagesToCompare: PagesToCompare,
});
